import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = t0 => {
  const $ = _c(12);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    resolvedTheme
  } = useTheme();
  const isDark = resolvedTheme === "dark";
  const t1 = isDark ? "dark" : "light";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["left", "right", "bottom"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isDark) {
    t3 = isDark ? {
      background: "rgb(23 23 23)",
      color: "rgb(255 255 255)",
      borderColor: "rgb(38 38 38)"
    } : undefined;
    $[3] = isDark;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      toast: "group toast !duration-200 group-[.toaster]:bg-white group-[.toaster]:text-neutral-950 group-[.toaster]:border-[var(--color-border)] group-[.toaster]:shadow-lg dark:group-[.toaster]:!bg-neutral-900 dark:group-[.toaster]:!text-white dark:group-[.toaster]:!border-[var(--color-border)]",
      description: "group-[.toast]:text-neutral-500 dark:group-[.toast]:text-neutral-400",
      actionButton: "group-[.toast]:!rounded-full group-[.toast]:!bg-[#313435] group-[.toast]:!text-white group-[.toast]:hover:!bg-[#161718] dark:group-[.toast]:!bg-[#f5f5f5] dark:group-[.toast]:!text-black",
      cancelButton: "group-[.toast]:!rounded-full group-[.toast]:!bg-transparent group-[.toast]:!text-[#202122] group-[.toast]:!border group-[.toast]:!border-[var(--color-border)] group-[.toast]:hover:!bg-[#e8e8e8] dark:group-[.toast]:!text-white dark:group-[.toast]:hover:!bg-[#313435]",
      icon: "text-neutral-900 dark:text-neutral-100 group-data-[type='error']:text-red-500",
      closeButton: "!absolute !left-auto !right-[-12px] max-sm:!right-2 !top-[-12px] !z-10 !size-6 !transform-none !rounded-full !border !border-[var(--color-border)] !bg-[var(--color-surface)] !text-neutral-500 !shadow-sm hover:!text-neutral-900 dark:hover:!text-white !opacity-0 !transition-opacity [@media(hover:hover)]:group-hover:!opacity-100 [@media(hover:none)]:!pointer-events-none focus-visible:!opacity-100 focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-[var(--focus-border)]"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = {
      style: t3,
      classNames: t4
    };
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t5) {
    t6 = <Sonner theme={t1} className="toaster group !font-sans" closeButton={true} swipeDirections={t2} toastOptions={t5} {...props} />;
    $[8] = props;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export { Toaster };